import { 
  SET_WALK_TEST_MODAL, 
  SET_WALK_TEST_FORM_DATA, 
  CLEAR_WALK_TEST_FORM_DATA 
} from '../actions/walkTestAction';

const initialState = {
  isModalOpen: false,
  formData: null,  // Will store second step form data
  dyspneaValues: {
    rest: "",
    max: "",
    recovery_1: "",
    recovery_2: "",
    recovery_3: "",
  },
  fatigueValues: {
    rest: "",
    max: "",
    recovery_1: "",
    recovery_2: "",
    recovery_3: "",
  },
  bpValues: {
    rest: "",
    max: "",
    recovery_1: "",
    recovery_2: "",
    recovery_3: "",
  }
};

const walkTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WALK_TEST_MODAL:
      return {
        ...state,
        isModalOpen: action.payload
      };
    
    case SET_WALK_TEST_FORM_DATA:
      return {
        ...state,
        formData: action.payload.formData || state.formData,
        dyspneaValues: action.payload.dyspneaValues || state.dyspneaValues,
        fatigueValues: action.payload.fatigueValues || state.fatigueValues,
        bpValues: action.payload.bpValues || state.bpValues
      };
    
    case CLEAR_WALK_TEST_FORM_DATA:
      return {
        ...state,
        formData: null,
        dyspneaValues: initialState.dyspneaValues,
        fatigueValues: initialState.fatigueValues,
        bpValues: initialState.bpValues
      };
      
    default:
      return state;
  }
};

export default walkTestReducer;
